import { observer } from "mobx-react";
import useFeature from "../../../useFeature";
import { useApplication } from "../../../ApplicationProvider";
import SalesByArticleCategoryFeature from "./SalesByArticleCategoryFeature";
import SalesByArticleFeature from "./SalesByArticleFeature";
import SalesByGroupTable from "./SalesByGroupTable";
import SalesByMixTable from "./SalesByMixTable";

function SalesByArticleCategoryChart({ filters, boxesMode, zoomedCategory, onZoomIntoCategory, onExitCategoryZoom }) {
    const application = useApplication();
    const categoryFeature = useFeature(
        () => new SalesByArticleCategoryFeature(application, filters),
        [application, JSON.stringify(filters)]
    );
    const articleFeature = useFeature(
        () => new SalesByArticleFeature(application, filters),
        [application, JSON.stringify(filters)]
    );

    const isZoomed = !!zoomedCategory;

    if (isZoomed) {
        return (
            <SalesByMixTable
                title="Ventas por Categoría de Artículos"
                groupHeader="Artículo"
                loaded={!!articleFeature?.loaded}
                data={articleFeature?.salesByArticle}
                boxesMode={boxesMode}
                breadcrumb={{ root: "Categorías", leaf: zoomedCategory, onExit: onExitCategoryZoom }}
            />
        );
    }

    return (
        <SalesByGroupTable
            title="Ventas por Categoría de Artículos"
            groupHeader="Categoría"
            loaded={!!categoryFeature?.loaded}
            data={categoryFeature?.salesByArticleCategory}
            boxesMode={boxesMode}
            onGroupClick={onZoomIntoCategory}
        />
    );
}

export default observer(SalesByArticleCategoryChart);
